import React from "react";
import styles from "../styles/Terms.module.css";
import Header from "./Header";
import Footer from "./Footer";

export default function Terms() {
  return (
    <main className={styles.page}>
      <div className={styles.container}>
        <h1>Terms of Service</h1>

        <p className={styles.updated}>
          Last updated: August 30, 2026
        </p>

        <p>
          These Terms of Service govern your use of PaySlipMadeSimple.
          By accessing or using the website, you agree to these Terms.
          If you do not agree with these Terms, you should not use the
          website.
        </p>

        <h2>1. About PaySlipMadeSimple</h2>

        <p>
          PaySlipMadeSimple is a free online payroll calculation and payslip
          generation tool operated by CyTechSharp.
        </p>

        <p>
          The service allows users to enter payroll information, calculate
          estimated employee deductions and employer contributions, determine
          net payable amounts, and generate payslip PDF documents.
        </p>

        <h2>2. Free Service</h2>

        <p>
          PaySlipMadeSimple is currently provided free of charge.
        </p>

        <p>
          We reserve the right to modify, suspend, discontinue, or restrict
          any part of the service at any time, including individual features,
          without guaranteeing continued availability.
        </p>

        <h2>3. Payroll Calculations</h2>

        <p>
          PaySlipMadeSimple is a calculation tool and is not a substitute for
          professional payroll, accounting, tax, legal, or financial advice.
        </p>

        <p>
          Although we aim to use appropriate Cyprus statutory rates and
          calculation methods, we do not guarantee that every calculation will
          be accurate, complete, current, or applicable to every individual
          employment situation.
        </p>

        <p>
          Payroll legislation, tax rates, contribution rates, thresholds,
          exemptions, ceilings, and other requirements may change.
        </p>

        <p>
          You are responsible for verifying calculations against current
          requirements and, where appropriate, obtaining advice from a
          qualified payroll professional, accountant, tax adviser, or the
          relevant Cyprus authorities.
        </p>

        <h2>4. Payslip PDFs</h2>

        <p>
          Payslip PDFs generated by the website are generated from the
          information and settings provided by the user.
        </p>

        <p>
          You are responsible for reviewing the generated payslip before
          using, distributing, submitting, or relying on it.
        </p>

        <p>
          We do not guarantee that a generated payslip will satisfy every
          legal, accounting, employment, banking, tax, or administrative
          requirement.
        </p>

        <h2>5. User Responsibility</h2>

        <p>
          You are responsible for ensuring that the information you enter is
          accurate, complete, and lawful.
        </p>

        <p>
          You must not use PaySlipMadeSimple to create documents for
          fraudulent, deceptive, unlawful, or otherwise abusive purposes.
        </p>

        <p>
          You are also responsible for protecting any payroll information
          entered into the website and any generated PDF files downloaded to
          your device.
        </p>

        <h2>6. No Server-Side Payroll Database</h2>

        <p>
          The calculator currently performs its calculations and generates
          payslip PDFs within the user's browser.
        </p>

        <p>
          PaySlipMadeSimple does not currently provide an online payroll
          account, employee database, or server-side payroll storage service.
        </p>

        <h2>7. Cookies and Saved Form Information</h2>

        <p>
          The website may use first-party cookies to save form information
          locally on your device so that previously entered information can be
          restored.
        </p>

        <p>
          You can manage or delete these cookies through your browser
          settings. Blocking cookies may affect the functionality of the
          calculator.
        </p>

        <h2>8. Advertising and Third-Party Services</h2>

        <p>
          PaySlipMadeSimple may display advertisements and may use third-party
          services to provide advertising, analytics, security, hosting, or
          other functionality.
        </p>

        <p>
          Third-party services may have their own terms, privacy policies,
          cookies, and data-processing practices.
        </p>

        <p>
          Your use of third-party services through or in connection with the
          website may therefore also be subject to the applicable terms of
          those providers.
        </p>

        <h2>9. Intellectual Property</h2>

        <p>
          Unless otherwise stated, the PaySlipMadeSimple website, including
          its software, design, branding, text, graphics, and original
          content, is owned by or licensed to CyTechSharp.
        </p>

        <p>
          You may use the website and generated payslip documents for lawful
          personal or business purposes. You may not copy, reproduce,
          redistribute, reverse engineer, or commercially exploit the website
          or its underlying software without permission, except where
          permitted by applicable law.
        </p>

        <h2>10. Availability</h2>

        <p>
          We aim to keep PaySlipMadeSimple available and functioning properly,
          but we do not guarantee uninterrupted, error-free, or continuous
          access to the website.
        </p>

        <p>
          The service may become temporarily unavailable due to maintenance,
          technical problems, hosting issues, security incidents, third-party
          service failures, or circumstances outside our reasonable control.
        </p>

        <h2>11. Disclaimer of Warranties</h2>

        <p>
          To the maximum extent permitted by applicable law, PaySlipMadeSimple
          is provided on an "as is" and "as available" basis without warranties
          of any kind, whether express or implied.
        </p>

        <p>
          We do not warrant that the website, calculations, generated
          documents, or information provided through the service will always
          be accurate, complete, current, uninterrupted, or suitable for a
          particular purpose.
        </p>

        <h2>12. Limitation of Liability</h2>

        <p>
          To the maximum extent permitted by applicable law, CyTechSharp shall
          not be liable for losses, damages, costs, claims, or expenses arising
          from or relating to your use of, or inability to use,
          PaySlipMadeSimple, including reliance on payroll calculations or
          generated payslip documents.
        </p>

        <p>
          Nothing in these Terms excludes or limits liability where doing so
          would be prohibited by applicable law.
        </p>

        <h2>13. Indemnification</h2>

        <p>
          To the extent permitted by applicable law, you agree to be
          responsible for claims, losses, liabilities, and reasonable expenses
          arising from your unlawful use of the website, violation of these
          Terms, or misuse of the service.
        </p>

        <h2>14. Changes to the Service or Terms</h2>

        <p>
          We may update these Terms from time to time. Changes will become
          effective when the updated Terms are published on this page unless
          applicable law requires otherwise.
        </p>

        <p>
          Your continued use of PaySlipMadeSimple after changes are published
          constitutes acceptance of the updated Terms.
        </p>

        <h2>15. Governing Law</h2>

        <p>
          These Terms shall be governed by the laws applicable in the Republic
          of Cyprus, subject to any mandatory consumer protection or other
          applicable legal requirements.
        </p>

        <h2>16. Contact</h2>

        <p>
          Questions regarding these Terms can be directed to:
        </p>

        <p>
          <strong>CyTechSharp</strong>
          <br />
          sharpdevelopmentcy@gmail.com
        </p>
      </div>
    </main>
  );
}